import { defineMessages } from 'react-intl';

export const messages: {
	externalPersonLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	externalPersonLabel: {
		id: 'search-result.user-mention.external-person',
		defaultMessage: 'External person',
		description: 'Label for external person in user mention',
	},
});
